// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3oAoe","footer":"ModalUpdate_footer__23ccN"};